import BaseEntityService from "core/framework/BaseEntityService";
import env from "environment";

class CustomerService extends BaseEntityService {
  constructor() {
    super({
      baseUrl: env.baseUrl + "/customers"
    });
  }
}

const service = new CustomerService();

export default service;
